import styled from 'styled-components';
import { CARD_CORNER } from '../Card/styled';

/** A full deck: 60 cards. */
const FULL_DECK = 60;
/** How far a full deck's stack of edges shows past its top card, against the card's width (seen from a little off top). */
const FULL_DEPTH = 0.09;
/** One edge line per this many cards, so the stack reads as cards rather than a block. */
const CARDS_PER_EDGE = 4;

/**
 * The deck seen as a stack: card edges showing below and to the right of the top card, as many as the deck is thick,
 * and its shadow falling as far. It thins out as cards are drawn.
 *
 * @param {number} count cards in the deck
 * @returns {{ x: number, y: number, blur: number, color: string }[]} each layer's offset and blur against the card's
 *   width, the edges first and the shadow last
 */
export function deckLayers(count) {
  const depth = (Math.min(count, FULL_DECK) / FULL_DECK) * FULL_DEPTH;
  const edges = Math.max(1, Math.ceil(Math.min(count, FULL_DECK) / CARDS_PER_EDGE));
  const layers = [];
  for (let i = 1; i <= edges; i++) {
    const offset = (depth * i) / edges;
    // Face down, a stack shows the blue of the card backs' border (pokemon-card.jpg), a lighter and a darker line
    // in turn so the cards read one by one.
    layers.push({ x: offset * 0.35, y: offset, blur: 0, color: i % 2 ? '#1d4a8f' : '#0b2f66' });
  }
  layers.push({ x: depth * 0.35 + 0.02, y: depth + 0.04, blur: 0.08, color: 'rgba(0, 0, 0, .55)' });
  return layers;
}

const atCardWidth = (fraction) => `calc(var(--card-w, 64px) * ${fraction.toFixed(4)})`;

/** deckLayers as a box-shadow. */
export const deckEdges = (count) => deckLayers(count)
  .map(({ x, y, blur, color }) => `${atCardWidth(x)} ${atCardWidth(y)} ${atCardWidth(blur)} ${color}`)
  .join(', ');

export const DeckStack = styled.span`
  display: block;
  line-height: 0;
  border-radius: calc(var(--card-w, 64px) * ${CARD_CORNER});
  box-shadow: ${({ $count }) => deckEdges($count)};
`;
